<template>
  <Modal
    :show="show"
    width="366"
    cancel-text=""
    action-text=""
    @close="handleClose"
  >
    <template #title>
      <span class="text-h2">Move Job Family</span>
    </template>
    <template #content>
      <p class="text-body-1 text-textDarkest mb-4">
        Set a new job family group for the selected job family.
      </p>
      <JobFamilyGroupSelect
        v-model="selectedGroupUlid"
        :groups="groups"
        placeholder="Select Job Family Group"
      />
      <p class="move-apply-line text-body-1 text-textDark mb-0 mt-4">
        {{ applyLine }}
      </p>
    </template>
    <template #actions>
      <DpplNewButton
        class="bulk-modal-action text-button-1"
        variant="flat"
        color="primary"
        :disabled="!selectedGroupUlid"
        :loading="loading"
        @click="handleConfirm"
      >
        Update
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import JobFamilyGroupSelect from '@/components/shared/JobFamilyGroupSelect.vue';
import { formatFamilyUsage } from '@/components/jobArchitecture/helpers';

const props = defineProps({
  show: { type: Boolean, default: false },
  groups: { type: Array, default: () => [] },
  profileCount: { type: Number, default: 0 },
  draftCount: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);

const selectedGroupUlid = ref(null);

const usage = computed(() => formatFamilyUsage({
  profileCount: props.profileCount,
  draftCount: props.draftCount,
}));

const applyLine = computed(() => {
  if (!selectedGroupUlid.value || !usage.value) {
    return '';
  }

  return `This will apply to ${usage.value}.`;
});

const reset = () => {
  selectedGroupUlid.value = null;
};

const handleClose = () => {
  reset();
  emit('close');
};

const handleConfirm = () => {
  if (!selectedGroupUlid.value) {
    return;
  }

  const match = (props.groups || []).find((group) => group.ulid === selectedGroupUlid.value);

  emit('confirm', {
    toGroupUlid: selectedGroupUlid.value,
    toGroupName: match?.name || '',
  });
};

watch(() => props.show, (isOpen) => {
  if (!isOpen) {
    reset();
  }
});
</script>

<style scoped lang="less">
.bulk-modal-action {
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}

.move-apply-line {
  min-height: 20px;
}
</style>
